import * as angular from 'angular';
import Trial from "./trial/trial";
import NewMsisdn from "./new-msisdn/new.msisdn";
import LinkNotification from "./link/link.notification";
import VoicemailRecording from "./voicemail-recording/voicemail.recording";
import Notifications from "./notifications";
import NotificationsService from "./notifications.service";

export default angular.module('CrazyWeb.Theme.Notifications', [])
    .component("trial", Trial)
    .component("newMsisdn", NewMsisdn)
    .component("linkNotification", LinkNotification)
    .component("voicemailRecording", VoicemailRecording)
    .component("notifications", Notifications)
    .service("NotificationsService", NotificationsService)
    .name
